export const PRODUCT_ENDPOINTS = {
  EXPLORE_LIST: '/products/explore/',
  EXPLORE_DETAIL: (slug: string) => `/products/explore/${slug}/`,
  REVIEW: '/products/review/',
  REVIEWS: (slug: string) => `/products/review/${slug}/`,
  ADD_REVIEW: (slug: string) => `/products/review/${slug}/add/`,
  CATEGORIES: '/products/category/',
} as const
